document.querySelectorAll('.breed-tab').forEach(tab => {
    tab.addEventListener('click', () => {
        // Update active state
        document.querySelector('.breed-tab.active').classList.remove('active');
        tab.classList.add('active');

        // Toggle visibility of breed grids
        document.getElementById('breedGridDogs').style.display = tab.dataset.type === 'dogs' ? 'grid' : 'none';
        document.getElementById('breedGridCats').style.display = tab.dataset.type === 'cats' ? 'grid' : 'none';
    });
});

window.addEventListener("scroll", () => {
  // alert('asdf');
    const header = document.querySelector("nav");
    if (window.scrollY > 150) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  });

const menuButtons = document.querySelectorAll('.menu-button');
const mobileMenu = document.querySelector('.mobile-menu');
const mobileNavLinks = document.querySelectorAll('.mobile-nav-link')
// Toggle mobile menu
menuButtons.forEach(button => {
    button.addEventListener('click', () => {
        const isOpen = mobileMenu.classList.contains('active');
        mobileMenu.classList.toggle('active');
        document.body.style.overflow = isOpen ? '' : 'hidden';
    });
})
// Toggle mobile nav items
mobileNavLinks.forEach(link => {
    link.addEventListener('click', (e) => {
        const content = link.nextElementSibling;
        const arrow = link.querySelector('.arrow-icon');
        
        if (content) {
            e.preventDefault();
            
            // Remove active class from all other links and content
            mobileNavLinks.forEach(otherLink => {
                if (otherLink !== link) {
                    otherLink.classList.remove('active');
                    const otherArrow = otherLink.querySelector('.arrow-icon');
                    const otherContent = otherLink.nextElementSibling;
                    if (otherArrow) otherArrow.classList.remove('active');
                    if (otherContent) otherContent.classList.remove('active');
                }
            })
            // Toggle current link and content
            link.classList.toggle('active');
            content.classList.toggle('active');
            if (arrow) arrow.classList.toggle('active');
        }
    });
});

const searchBar = document.querySelector('.search-bar');
const responsiveSearchBar = document.querySelector('.responsive-search-bar');

// Sync input values between the two search bars
searchBar.addEventListener('input', () => {
    responsiveSearchBar.value = searchBar.value;
});

responsiveSearchBar.addEventListener('input', () => {
    searchBar.value = responsiveSearchBar.value;
});

// Optionally, handle form submission
document.getElementById('desktopSearchForm').addEventListener('submit', (e) => {
    // Prevent the default behavior if needed
    // e.preventDefault();
    console.log('Desktop form submitted with:', searchBar.value);
});

document.getElementById('mobileSearchForm').addEventListener('submit', (e) => {
    // Prevent the default behavior if needed
    // e.preventDefault();
    console.log('Mobile form submitted with:', responsiveSearchBar.value);
});
